import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { can } from '@/auth/me'

/** Super admin area. The database enforces this too; the redirect just keeps the UI tidy. */
export const Route = createFileRoute('/_app/admin')({
  beforeLoad: ({ context }) => {
    if (!can(context.me, 'admin') || context.me.impersonating) throw redirect({ to: '/' })
  },
  component: Outlet,
})
